import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202606",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 9849,
  clicks: 225,
  adsSpendDollars: 900,
  budgetDollars: 900,
  salesDollars: 8824,
  bestEstimateRoas: 9.8,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  reorderConversions: 30,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
